var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5833 13.75C15.5833 13.0625 16.1458 12.5 16.8333 12.5C17.5271 12.5 18.0833 13.0562 18.0833 13.75C18.0833 14.4438 17.5208 15 16.8333 15C16.1458 15 15.5833 14.4375 15.5833 13.75Z",
    fill: "#CB0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3333 16.875V17.5H14.3333V16.875C14.3333 16.0438 16.0021 15.625 16.8333 15.625C17.6646 15.625 19.3333 16.0438 19.3333 16.875Z",
    fill: "#CB0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98334 11.25H7.18334V8.85H9.58334V7.65H5.98334V11.25ZM9.33334 22V20H5.13334C4.63334 20 4.20834 19.825 3.85834 19.475C3.50834 19.125 3.33334 18.7 3.33334 18.2V6.8C3.33334 6.3 3.50834 5.875 3.85834 5.525C4.20834 5.175 4.63334 5 5.13334 5H20.5333C21.0333 5 21.4583 5.175 21.8083 5.525C22.1583 5.875 22.3333 6.3 22.3333 6.8V18.2C22.3333 18.7 22.1583 19.125 21.8083 19.475C21.4583 19.825 21.0333 20 20.5333 20H16.3333V22H9.33334ZM5.13334 18.5H20.5333C20.6 18.5 20.6667 18.4667 20.7333 18.4C20.8 18.3333 20.8333 18.2667 20.8333 18.2V6.8C20.8333 6.73333 20.8 6.66667 20.7333 6.6C20.6667 6.53333 20.6 6.5 20.5333 6.5H5.13334C5.06668 6.5 5.00001 6.53333 4.93334 6.6C4.86668 6.66667 4.83334 6.73333 4.83334 6.8V18.2C4.83334 18.2667 4.86668 18.3333 4.93334 18.4C5.00001 18.4667 5.06668 18.5 5.13334 18.5Z",
    fill: "#CB0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraOn);
export default __webpack_public_path__ + "static/media/cameraOn.27af1115caaf4d4d5005c920923a2e23.svg";
export { ForwardRef as ReactComponent };